module.exports = __webpack_public_path__ + "media/images/static/top/local/photo3_mobile-63af28177c2ba43287205056f2cec3f7.png";